import * as React from "react";

// material-ui
import makeStyles from "@material-ui/styles/makeStyles";
import Card from "@material-ui/core/Card";

import Divider from "@material-ui/core/Divider";

import { PageHeader, PageFooter, SimpleShowLayout, TextField, FunctionField, BackButton, EditButton } from "jazasoft";
import CardHeader from "../../../components/CardHeader";
import { fieldOptions } from "../../../utils/helpers";

import MuiTable from "../../../components/MuiTable";
import useQuery from "../../../hooks/useQuery";
import { useEntityPrivilege } from "../../../hooks";
import { AlertParameterFields } from "../../../utils/entityFields";
import { Role, AlertParemeter as Parameter } from "../../../utils/types";

const paramMap = Object.values(Parameter).reduce((acc, e) => ({ ...acc, [e.id]: e.name }), {});

const columns = [
  { dataKey: "impact", title: "Impact" },
  { dataKey: "reason", title: "Reason" }
];

const useStyles = makeStyles({
  content: {
    margin: "1.5em"
  },
  pageFooter: {
    "& > *": {
      marginRight: "1em"
    }
  }
});

const AlertParameterView = props => {
  const classes = useStyles();
  const { id, i18nKey, resource, basePath, roles } = props;
  const { disableEdit } = useEntityPrivilege(resource);

  // api call
  const { data: alertParameter = {} } = useQuery({ url: `${resource}/${id}` });

  // const fields = useSetting(SettingKeys.ENTITY_FIELDS, resource);
  const fields = ["parameter", "minusTolerance", "plusTolerance", "toleranceUnit", "desc"];
  return (
    <div>
      <PageHeader title={`Alert Parameter #${id}`} />

      <div className={classes.content}>
        <Card>
          <CardHeader title="Basic Info" />
          <Divider />
          <SimpleShowLayout style={{ padding: "1em" }} record={alertParameter} i18nKey={i18nKey} footer={false}>
            {fields.includes(AlertParameterFields.PARAMETER) && (
              <FunctionField source="parameter" render={record => paramMap[record.parameter]} {...fieldOptions(3)} />
            )}
            {fields.includes(AlertParameterFields.DESC) && <TextField source="desc" {...fieldOptions(5)} />}
            {fields.includes(AlertParameterFields.MINUS_TOLERANCE) && (
              <FunctionField
                source="minusTolerance"
                render={record => `${record.minusTolerance || "-"} ${record.toleranceUnit || ""}`}
                {...fieldOptions(2)}
              />
            )}
            {fields.includes(AlertParameterFields.PLUS_TOLERANCE) && (
              <FunctionField
                source="plusTolerance"
                render={record => `${record.plusTolerance || "-"} ${record.toleranceUnit || ""}`}
                {...fieldOptions(2)}
              />
            )}
          </SimpleShowLayout>
        </Card>

        <Card style={{ marginTop: "1em" }}>
          <CardHeader title="Alert Reasons" />
          <Divider />
          <div>
            <MuiTable columns={columns} rows={alertParameter?.alertParameterItems?.sort((a, b) => b.id - a.id)} />
          </div>
        </Card>

        <PageFooter className={classes.pageFooter}>
          <BackButton variant="contained" basePath={basePath} resource={resource} />
          {(roles?.includes(Role.MASTER) || roles?.includes(Role.SUPER_USER)) && !disableEdit && (
            <EditButton variant="contained" color="primary" basePath={basePath} resource={resource} to="edit" />
          )}
        </PageFooter>
      </div>
    </div>
  );
};

export default AlertParameterView;
